
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface InitialResponseGeneratorProps {
  onGenerate: () => Promise<void>;
  isGenerating: boolean;
}

const InitialResponseGenerator = ({ onGenerate, isGenerating }: InitialResponseGeneratorProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Generate First Response</CardTitle>
        <CardDescription>
          Create your initial refund request message
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button 
          onClick={onGenerate}
          disabled={isGenerating}
          className="w-full"
        >
          {isGenerating ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Generating...
            </>
          ) : (
            <>Generate Refund Request</>
          )}
        </Button>
      </CardContent>
    </Card>
  );
};

export default InitialResponseGenerator;
